import { useEffect, useState } from "react";
import Layout from "@/components/Layout";
import api from "@/lib/api";
import { fmtMoney, fmtPrice, timeAgo } from "@/lib/format";

const STATUS_TAG = {
  filled: "buy",
  pending: "hold",
  rejected: "sell",
  cancelled: "sell",
};

export default function History() {
  const [orders, setOrders] = useState([]);
  const [audit, setAudit] = useState([]);

  useEffect(() => {
    const load = async () => {
      const [o, a] = await Promise.all([
        api.get("/orders", { params: { limit: 100 } }),
        api.get("/audit", { params: { limit: 50 } }),
      ]);
      setOrders(o.data);
      setAudit(a.data);
    };
    load();
    const id = setInterval(load, 12000);
    return () => clearInterval(id);
  }, []);

  return (
    <Layout>
      <div className="p-6 grid grid-cols-1 xl:grid-cols-3 gap-4">
        <div className="xl:col-span-2 panel" data-testid="orders-table">
          <div className="panel-header">
            <span>Trade Journal</span>
            <span className="text-[10px] font-mono text-[#4B5563]">{orders.length} orders</span>
          </div>
          <table className="w-full text-xs">
            <thead className="border-b border-[#272A30] text-[10px] uppercase tracking-[0.2em] text-[#8B95A5]">
              <tr>
                <th className="text-left p-3">Time</th>
                <th className="text-left p-3">Symbol</th>
                <th className="text-left p-3">Side</th>
                <th className="text-left p-3">Source</th>
                <th className="text-right p-3">Qty</th>
                <th className="text-right p-3">Price</th>
                <th className="text-right p-3">Notional</th>
                <th className="text-left p-3">Status</th>
              </tr>
            </thead>
            <tbody>
              {orders.length === 0 ? (
                <tr><td colSpan={8} className="p-8 text-center text-xs text-[#4B5563]">No trades yet.</td></tr>
              ) : orders.map((o) => (
                <tr key={o.id} className="border-b border-[#272A30] hover:bg-[#1A1D24]" data-testid={`order-row-${o.id}`}>
                  <td className="p-3 font-mono text-[#8B95A5]">{timeAgo(o.placed_at)}</td>
                  <td className="p-3"><span className="font-medium">{o.symbol}</span> <span className="text-[10px] text-[#4B5563] uppercase">{o.asset_class}</span></td>
                  <td className="p-3"><span className={`tag ${o.side === "buy" ? "buy" : "sell"}`}>{o.side}</span></td>
                  <td className="p-3 text-[10px] uppercase tracking-[0.16em] text-[#8B95A5] font-mono">{o.source.replace("_", " ")}</td>
                  <td className="p-3 text-right font-mono">{fmtPrice(o.quantity, 4)}</td>
                  <td className="p-3 text-right font-mono">{fmtPrice(o.price)}</td>
                  <td className="p-3 text-right font-mono">{fmtMoney(o.price * o.quantity)}</td>
                  <td className="p-3"><span className={`tag ${STATUS_TAG[o.status] || ""}`}>{o.status}</span></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="panel" data-testid="audit-list">
          <div className="panel-header"><span>Audit Trail</span></div>
          <div className="max-h-[600px] overflow-y-auto">
            {audit.length === 0 ? (
              <div className="p-4 text-xs text-[#4B5563] text-center">No audit entries.</div>
            ) : audit.map(a => (
              <div key={a.id} className="px-4 py-2 border-b border-[#272A30] text-xs">
                <div className="flex items-center justify-between">
                  <span className="font-mono text-[10px] text-[#8B95A5] uppercase tracking-[0.18em]">{a.action}</span>
                  <span className="text-[10px] text-[#4B5563] font-mono">{timeAgo(a.created_at)}</span>
                </div>
                <div className="text-[#F8F9FA] mt-1">{a.detail}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </Layout>
  );
}
